import { SearchPageResultsPlaceholderCard } from "./SearchPageResultsPlaceholderCard";

export const SearchPageResultsPlaceholderContainer = ({ numberOfCards }) => {
	const placeholderCards = new Array(numberOfCards).fill(<SearchPageResultsPlaceholderCard />);
	return <>{placeholderCards}</>;
};
